module.exports = __webpack_public_path__ + "static/feature_cash-4682b150dbf5ee38df6077ff79c51e45.png";